// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
       // serverUrl: 'https://devapi.vidhyadhan.in',
    // socketioUrl: 'https://devapi.vidhyadhan.in:8080',
     // serverUrl: 'https://devapi.vidhyadhan.in',
     socketioUrl: 'https://devapi.vidhyadhan.in:3000',
     socketioNewUrl: 'devapi.vidhyadhan.in:3001',

  // serverUrl: 'http://localhost:8000',
  // serverUrl: 'https://demoapi.vidhyadhan.in',
  serverUrl: 'https://tensapi.vidhyadhan.ae',
  //serverUrl: 'http://localhost:8000',
  // socketioUrl: 'http://localhost:3000'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
